export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 20px',
    gap: '12px',
    width: '100%',
    height: '52px',
    border: '1px solid #EDEFF7',
    borderRadius: '12px',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    userSelect: 'none',
  },
  label: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '148%',
    color: '#23252F',
  },
};
